import { useDrawer } from '../hooks/useDrawer';

type DrawerContentProps = {
	children: React.ReactNode;
	isOpen: boolean;
};

const DrawerContent = ({ children, isOpen }: DrawerContentProps) => {
	const { blockClass } = useDrawer();

	const renderClass = () => blockClass && `vtex-store-drawer-0-x-drawer--${blockClass} drawer--${blockClass}`;

	const renderStyles = () => {
		if (isOpen) {
			return {
				width: '85%',
				maxWidth: '450px',
				minWidth: '280px',
				pointerEvents: 'auto' as const,
				transform: 'translate3d(0%, 0px, 0px)',
				trasition: '.5s',
			};
		}

		return {
			width: '85%',
			maxWidth: '450px',
			minWidth: '280px',
			pointerEvents: 'auto' as const,
			transform: 'translate3d(-100%, 0px, 0px)',
			trasition: '.5s',
		};
	};

	return (
		<div
			className={`vtex-store-drawer-0-x-drawer drawer ${renderClass()} vtex-store-drawer-0-x-opened opened left-0 absolute top-0 bottom-0 bg-base z-999 flex flex-column`}
			style={renderStyles()}
		>
			<div
				className={`vtex-store-drawer-0-x-drawerContent drawerContent vtex-store-drawer-0-x-drawerContent--${blockClass} drawerContent--${blockClass} overflow-y-auto`}
			>
				{children}
			</div>
		</div>
	);
};

export default DrawerContent;
